<template>
    <div>
        <b-modal size="lg" title="Create Order" v-model="addModal" hide-footer>
            <create-order-form
                @success="orderCreated"
                @cancel="addModal = false"
            />
        </b-modal>

        <b-modal
            v-model="importModal"
            size="xl"
            hide-footer
            no-close-on-backdrop
        >
            <import-orders-form
                @success="importModal = false"
                @cancel="importModal = false"
            />
        </b-modal>

        <b-container fluid class="mt--7">
            <b-row>
                <b-col>
                    <order-table
                        title="Users"
                        @add="addModal = true"
                        @import="importModal = true"
                        ref="table"
                    >
                    </order-table>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import OrderTable from './OrderTable'
import CreateOrderForm from './CreateOrderForm'
import ImportOrdersForm from './ImportOrdersForm'

export default {
    name: 'orders',
    mixins: [popupMixins],
    components: {
        OrderTable,
        CreateOrderForm,
        ImportOrdersForm,
    },
    data: () => {
        return {
            addModal: false,
            importModal: false,
        }
    },

    methods: {
        orderCreated() {
            this.addModal = false
            this.$refs.table.doSearch(true)
            this.doToast('Success', `Order Created`, 'success')
        },
    },
}
</script>
